'use client';

import styles from './modalHeader.module.scss';
import { useModalTitleId } from './ModalTitleContext';
import { ModalHeaderProps } from './types';

export function ModalHeader({
  size = 'large',
  title,
  titleIcon,
  children,
}: ModalHeaderProps) {
  const titleId = useModalTitleId();

  return (
    <div className={styles.header} data-size={size}>
      <h2 id={titleId} className={styles.title}>
        {titleIcon && <span aria-hidden="true">{titleIcon}</span>}
        {title}
      </h2>
      <div className={styles.right}>{children}</div>
    </div>
  );
}

ModalHeader.displayName = 'ModalHeader';
